import { motion } from 'framer-motion'
import Cookies from 'js-cookie'
import React, { useState, useEffect, useRef } from 'react'

import {
  RiExternalLinkLine,
  RiArrowRightLine,
  RiCloseCircleLine,
} from 'react-icons/ri'

import Classnames from 'classnames'

function PublicHelloBar({ collection, hideBar, absolute }) {
  // useEffect(() => {
  //   // scroll top on load
  //   window.scrollTo(0, 0)
  // }, [collection])

  function findGetParameter(parameterName) {
    var result = null,
      tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      })
    return result
  }

  let showBar = true
  let getCookie = Cookies.get('hide-promo-bar-' + collection._id)
  // check if cookie is set to hide it
  if (getCookie) {
    showBar = false
  }

  if (showBar) {
    return (
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.15 }}
        variants={{
          hidden: {
            opacity: 0,
          },
          visible: {
            opacity: 1,
          },
          exit: {
            opacity: 0,
            height: 0,
            // y: -48,
          },
        }}
        style={{ backgroundColor: collection.header_bg_color, zIndex: 999999 }}
        className={Classnames(
          'bg-white shadow-inner border-b-2 border-t-2 border-black relative border-opacity-20',
          {
            // 'absolute top-16 w-full shadow-md': absolute,
          }
        )}
      >
        <div
          className={Classnames('container relative   flex items-center ', {
            // 'justify-between px-10': absolute,
            'max-w-7xl justify-center mx-auto': true,
          })}
        >
          <div className="flex flex-col md:flex-row items-center font-bold text-white text-lg py-2.5">
            {collection.header_cta_text && (
              <div
                className={Classnames(
                  'flex md:items-center mb-2 pr-12 pl-5 md:pl-0 md:pr-0 md:mb-0',
                  {
                    'text-black': collection.header_text_color == 'black',
                    'text-white': collection.header_text_color == 'white',
                  }
                )}
              >
                <RiArrowRightLine className="mr-2 opacity-60 mt-2 md:mt-0" />
                {collection.header_cta_text}
              </div>
            )}

            {collection.header_cta_button_text !== 'undefined' && (
              <button
                onClick={() => {
                  window.open(collection.header_cta_link, '_blank')
                  // analytics.track('Promo Bar Link Click')
                }}
                className=" inline-flex items-center rounded text-white ml-4 py-2 md:py-0 px-3 font-bold bg-black"
              >
                {collection.header_cta_button_text}
                <RiExternalLinkLine className="ml-2" />
              </button>
            )}
          </div>
          {/* close bar */}
          <div
            onClick={() => {
              // set cookie for this to hide it
              // Cookies.set('hide-promo-bar-' + collection._id, true, {
              //   expires: 1,
              //   path: '',
              // })

              hideBar()
              // analytics.track('Hide Promo Bar')
            }}
            className={Classnames(
              'absolute right-2 md:right-0 top-2 md:top-auto cursor-pointer hover:text-opacity-75 text-2xl',
              {
                'text-black': collection.header_text_color == 'black',
                'text-white': collection.header_text_color == 'white',
              }
            )}
          >
            <RiCloseCircleLine />
          </div>
        </div>
      </motion.div>
    )
  } else {
    return null
  }
}

export default PublicHelloBar
